export function useDelayedRenderer(onRender, delay = 20) {
  let queue = [];
  let rendering = false;
  let timeoutId = null;

  function processQueue() {
    if (!queue.length) {
      rendering = false;
      timeoutId = null;
      return;
    }

    rendering = true;

    // Drain the whole queue per tick so bursty token arrival produces a single
    // re-render instead of one per chunk (keeps streaming smooth, esp. with a file chip).
    const chunk = queue.join("");
    queue = [];
    if (chunk) {
      onRender(chunk);
    }

    timeoutId = setTimeout(processQueue, delay);
  }

  function pushChunk(chunk) {
    queue.push(chunk);

    if (!rendering) {
      processQueue();
    }
  }

  function flush() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    if (queue.length) {
      const chunk = queue.join("");
      queue = [];
      if (chunk) {
        onRender(chunk);
      }
    }

    rendering = false;
  }

  function stop({ flush: shouldFlush = false } = {}) {
    if (shouldFlush) {
      flush();
      return;
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    queue = [];
    rendering = false;
  }

  return {
    pushChunk,
    flush,
    stop,
  };
}
